export default class RequestHandlerService {
    constructor() {
        this.pendingRefreshDeferred = [];
        this.pendingNewRefreshToken = false;
    }

    AddNewDeferred(deferredFunction) {
        this.pendingRefreshDeferred.push(deferredFunction);
    }

    finishedRefresh() {
        this.pendingNewRefreshToken = false;

        for (const i in this.pendingRefreshDeferred) {
            this.pendingRefreshDeferred[i](success);
        }
        this.pendingRefreshDeferred = [];
    }
}


/**
 * Created by charris on 4/9/2015.
 */
// (function(){
// 'use strict';
// angular.module('HeroPRO')
//   .service('requestHandlerService', function () {

//     //this is a singleton of the pending requests that need to be made that were queued up as a result of a expire token.. The first request to claim the pendingNewRefreshToken "mutex"
//     this.pendingRefreshDeferred = [];
//     this.pendingNewRefreshToken = false;

//     this.AddNewDeferred = function (_deferredFunction) {
//       this.pendingRefreshDeferred.push(_deferredFunction);
//     };

//     this.finishedRefresh = function (success) {

//       this.pendingNewRefreshToken = false;

//       for (var i in this.pendingRefreshDeferred) {
//         this.pendingRefreshDeferred[i](success);
//       }
//       this.pendingRefreshDeferred = [];
//     };
//   });
// })();



// WEBPACK FOOTER //
// ./src/app/common/userAuthorization/requestHandler.service.js